import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import HeaderFooterLayout from "./HeaderFooterLayout";
import DefaultLayout from "./DefaultLayout";
import NativeBaseLayout from "./NativeBaseLayout";
var layouts = {
  "default": DefaultLayout,
  headerFooter: HeaderFooterLayout,
  nbLayout: NativeBaseLayout //nbLayout: null,

};

var LayoutWrapper = function LayoutWrapper(props) {
  // to get the text value of the assigned layout of each component
  var Layout = layouts[props.layout]; // if we have a registered layout render children with said layout

  if (Layout) {
    return /*#__PURE__*/_jsx(Layout, _objectSpread(_objectSpread({}, props), {}, {
      children: props.children
    }));
  } // if not render children with fragment


  return /*#__PURE__*/_jsx(DefaultLayout, _objectSpread(_objectSpread({}, props), {}, {
    children: props.children
  }));
};

export default LayoutWrapper;